import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-[#DEECFF] py-12">
      <div className="container mx-auto flex flex-col justify-center items-center">
        <div className="mb-6 md:mb-0 text-center">
          <h3 className="text-lg font-bold text-gray-800">FBOOTH</h3>
          <p className="text-gray-600">Your favorite Photo Booth booking</p>
          <p className="text-gray-400 mt-2">Vietnam © 2024</p>
        </div>
      </div>
    </footer>
  );
}
